import { render, staticRenderFns } from "./studenttemporary.vue?vue&type=template&id=54bd14e0"
import script from "./studenttemporary.vue?vue&type=script&lang=js"
export * from "./studenttemporary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports